import { batch } from "solid-js"
import type { Engine } from "./Engine.type"

export default function setEngineGridWidthHeight(
  engine: Engine,
  width: number,
  height: number,
) {
  batch(() => {
    engine.state.width = width
    engine.state.height = height
  })
}